// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","blue":"_1T4JxjV","white":"_2c4jpxM","transition":"\"css/base/transition.css\"","transition-default":"0.2s","icon":"_28xEjad","outer":"_11KsWGS"};